export type { LinkedSpacesState } from './reducer';
export { default } from './reducer';
